/**
 * EG Search (Meilisearch) – bootstrap.
 *
 * Wires up the modules once the DOM is ready.
 */
(function () {
  'use strict';

  let analyticsInitialized = false;
  let autocompleteInitialized = false;
  let resultsInitialized = false;

  function initAnalytics() {
    if (!analyticsInitialized && window.EGSearchAnalytics) {
      analyticsInitialized = true;
      // Analytics stays available sitewide for click + conversion attribution.
      window.EGSearchAnalytics.init(() => window.EGSearchResultsPage?.getCurrentQuery?.() || '');
    }
  }

  function initAutocomplete() {
    if (!autocompleteInitialized && window.EGSearchAutocomplete) {
      autocompleteInitialized = true;
      window.EGSearchAutocomplete.init();
    }
  }

  function initResults() {
    if (!resultsInitialized && window.EGSearchResultsPage) {
      resultsInitialized = true;
      window.EGSearchResultsPage.init();
    }
  }

  function init() {
    initAnalytics();
    initAutocomplete();
    initResults();
  }

  window.EGSearchInit = {
    init,
    initAutocomplete
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init, { once: true });
  } else {
    init();
  }
})();
